/**
 * vant 的一些组件的使用
 * 用到什么组件就注册一下
 */
/**
 * vant 的一些组件的使用
 */
import Vue from 'vue'
// eslint-disable-next-line standard/object-curly-even-spacing
import { Toast, Image as VanImage, Col, Row, List, Cell, Loading } from 'vant'

Vue.use(Toast)
Vue.use(VanImage)
Vue.use(Col)
Vue.use(Row)
Vue.use(List)
Vue.use(Cell)
Vue.use(Loading)



// WEBPACK FOOTER //
// ./src/common/vant.js